import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CalendarTableHelper } from 'server/shared/helpers/calendarTableHelper';
import { CustomTableHeaderComponent } from '../../custom-table/custom-table-header/custom-table-header.component';
import { format } from 'date-fns';

@Component({
  selector: 'app-custom-date-table-header',
  templateUrl: './custom-date-table-header.component.html',
  styleUrls: [
    './custom-date-table-header.component.scss',
    '../date-table-shared-styles.scss',
  ],
})
export class CustomDateTableHeaderComponent implements OnInit {
  @Input() calendarTableHelper?: CalendarTableHelper;
  @Input() activeDayIndex?: number;
  @Input() activeDayRange?: number;
  @Output() dayIndexSelected = new EventEmitter<number>();
  @ViewChild(CustomTableHeaderComponent)
  tableHeaderComponent?: CustomTableHeaderComponent;
  daySelectable = false;
  today: string = format(new Date(), 'yyyy.MM.dd');
  constructor() {}
  ngOnInit() {
    this.daySelectable = this.dayIndexSelected.observers.length > 0;
  }

  selectDay(index: number) {
    this.dayIndexSelected.emit(index);
  }
}
